import { render, staticRenderFns } from "./ModalRecetteEdition.vue?vue&type=template&id=2a1e4dea&"
import script from "./ModalRecetteEdition.vue?vue&type=script&lang=js&"
export * from "./ModalRecetteEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports